const RowData =[{
    title: 'Trending',
    url: '/trending/all/day',
},
{
    title : 'Originals',
    url :'/discover/movie?sort_by=popularity.desc',
},{
    title: 'Rated',
    url: '/movie/top_rated'
},
{
    title : 'Action',
    url : '/discover/movie?with_geners=28'
},
{
    title : 'Comedy',
    url : '/discover/movie?with_geners=35'
},{
    title : 'Horror',
    url : '/discover/movie?with_geners=27'
},
{
    title : 'Romance',
    url : '/discover/movie?with_geners=10749'
}]
export default RowData;